import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { KaligraphiModule } from '@kalidea/kaligraphi';
import { NgxsModule } from '@ngxs/store';
import { EditorModule } from '@tinymce/tinymce-angular';
import {
    SharedAllocationAccessibilityDetailComponent
} from 'src/app/_shared/components/allocation-accessibility/shared-allocation-accessibility-detail/shared-allocation-accessibility-detail.component';
import {
    SharedAllocationAccessibilityEditComponent
} from 'src/app/_shared/components/allocation-accessibility/shared-allocation-accessibility-edit/shared-allocation-accessibility-edit.component';
import {
    SharedAllocationDetailEnvelopeComponent
} from 'src/app/_shared/components/allocation-envelope/shared-allocation-detail-envelope/shared-allocation-detail-envelope.component';
import {
    SharedAllocationEditEnvelopeComponent
} from 'src/app/_shared/components/allocation-envelope/shared-allocation-edit-envelope/shared-allocation-edit-envelope.component';
import {
    AnalyticalPlanDistributerComponent
} from 'src/app/_shared/components/analytic-plan-distributer/analytical-plan-distributer.component';
import { BeneficiaryPickerComponent } from 'src/app/_shared/components/beneficiary-picker/beneficiary-picker.component';
import { LazyListPickerComponent } from 'src/app/_shared/components/lazy-list-picker/lazy-list-picker.component';
import {
    BeneficiaryPictureComponent
} from 'src/app/_shared/components/beneficiary-picture/beneficiary-picture/beneficiary-picture.component';
import { ButtonCloseComponent } from 'src/app/_shared/components/button-close/button-close.component';
import { ColorPickerComponent } from 'src/app/_shared/components/color-picker/color-picker.component';
import { SharedCommentEditComponent } from 'src/app/_shared/components/comment-edit/shared-comment-edit.component';
import {
    IconInvalidFormControlComponent
} from 'src/app/_shared/components/icon-invalid-form-control/icon-invalid-form-control.component';
import { InputCounterComponent } from 'src/app/_shared/components/input-counter/input-counter.component';
import {
    ListingAboveSearchbarContentDirective
} from 'src/app/_shared/components/listing/listing-above-searchbar-content.directive';
import { ListingActionGroupedDirective } from 'src/app/_shared/components/listing/listing-action-grouped.directive';
import {
    ListingAfterSearchbarButtonsDirective
} from 'src/app/_shared/components/listing/listing-after-searchbar-buttons.directive';
import {
    ListingBetweenTableAndPagingDirective
} from 'src/app/_shared/components/listing/listing-between-table-and-paging.directive';
import {
    ListingCountResultsLabelDirective
} from 'src/app/_shared/components/listing/listing-count-results-label.directive';
import { ListingFooterDirective } from 'src/app/_shared/components/listing/listing-footer.directive';
import { ListingHeaderDirective } from 'src/app/_shared/components/listing/listing-header.directive';
import { ListingQuickFiltersDirective } from 'src/app/_shared/components/listing/listing-quick-filters.directive';
import {
    ListingSearchbarContentDirective
} from 'src/app/_shared/components/listing/listing-searchbar-content.directive';
import { ListingTitleDirective } from 'src/app/_shared/components/listing/listing-title.directive';
import { ListingComponent } from 'src/app/_shared/components/listing/listing.component';
import { SharedMagazineComponent } from 'src/app/_shared/components/magazine/shared-magazine.component';
import {
    SharedMailContainerComponent
} from 'src/app/_shared/components/mail/shared-mail-container/shared-mail-container.component';
import {
    SharedMailPublipostageTagsComponent
} from 'src/app/_shared/components/mail/shared-mail-publipostage-tags/shared-mail-publipostage-tags.component';
import { SharedMailComponent } from 'src/app/_shared/components/mail/shared-mail/shared-mail.component';
import { PartNumberComponent } from 'src/app/_shared/components/part-number/part-number.component';
import {
    SharedAdvancedSettlementComponent
} from 'src/app/_shared/components/settlements/shared-advanced-settlement/shared-advanced-settlement.component';
import {
    SharedEditRepaymentScheduleComponent
} from 'src/app/_shared/components/settlements/shared-edit-repayment-schedule/shared-edit-repayment-schedule.component';
import {
    SharedPaymentMethodsComponent
} from 'src/app/_shared/components/settlements/shared-payment-methods/shared-payment-methods.component';
import {
    SharedAccountingBudgetsChildrenListComponent
} from 'src/app/_shared/components/shared-accounting-budgets-children-list/shared-accounting-budgets-children-list.component';
import {
    SharedAddressDetailComponent
} from 'src/app/_shared/components/shared-address/shared-address-detail/shared-address-detail.component';
import {
    SharedAddressEditComponent
} from 'src/app/_shared/components/shared-address/shared-address-edit/shared-address-edit.component';
import {
    SharedAdministrativeStatusComponent
} from 'src/app/_shared/components/shared-administrative-status/shared-administrative-status.component';
import {
    SharedAdvancedRuleCriterionParametersControlComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-criterion-parameters-control/shared-advanced-rule-criterion-parameters-control.component';
import {
    SharedAdvancedRuleCriterionParametersDetailComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-criterion-parameters-detail/shared-advanced-rule-criterion-parameters-detail.component';
import {
    SharedAdvancedRuleCriterionValueControlComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-criterion-value-control/shared-advanced-rule-criterion-value-control.component';
import {
    SharedAdvancedRuleCriterionValueComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-criterion-value/shared-advanced-rule-criterion-value.component';
import {
    SharedAdvancedRuleDetailTableComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-detail-table/shared-advanced-rule-detail-table.component';
import {
    SharedAdvancedRuleDetailComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-detail/shared-advanced-rule-detail.component';
import {
    SharedAdvancedRuleEditTableComponent
} from 'src/app/_shared/components/shared-advanced-rules/shared-advanced-rule-edit-table/shared-advanced-rule-edit-table.component';
import {
    SharedAllocationDetailComponent
} from 'src/app/_shared/components/shared-allocation/shared-allocation-detail/shared-allocation-detail.component';
import {
    SharedAllocationEditComponent
} from 'src/app/_shared/components/shared-allocation/shared-allocation-edit/shared-allocation-edit.component';
import {
    SharedAllocationExecutionComponent
} from 'src/app/_shared/components/shared-allocation/shared-allocation-execution/shared-allocation-execution.component';
import {
    SharedAllocationInformationsComponent
} from 'src/app/_shared/components/shared-allocation/shared-allocation-informations/shared-allocation-informations.component';
import {
    SharedAllocationListComponent
} from 'src/app/_shared/components/shared-allocation/shared-allocation-list/shared-allocation-list.component';
import {
    SharedAnalyticalPlanDistributerByAccountComponent
} from 'src/app/_shared/components/shared-analytical-plan-distributer-by-account/shared-analytical-plan-distributer-by-account.component';
import {
    SharedAnalyticalPlanDistributerByModelComponent
} from 'src/app/_shared/components/shared-analytical-plan-distributer-by-model/shared-analytical-plan-distributer-by-model.component';
import {
    SharedAnalyticalPlanDistributerByMovementComponent
} from 'src/app/_shared/components/shared-analytical-plan-distributer-by-movement/shared-analytical-plan-distributer-by-movement.component';
import {
    SharedAnalyticalPlanDistributerComponent
} from 'src/app/_shared/components/shared-analytical-plan-distributer/shared-analytical-plan-distributer.component';
import {
    SharedAnalyticalPlanPickerComponent
} from 'src/app/_shared/components/shared-analytical-plan-picker/shared-analytical-plan-picker.component';
import {
    SharedBeneficiaryContactSelectionComponent
} from 'src/app/_shared/components/shared-beneficiary-contact-selection/shared-beneficiary-contact-selection.component';
import {
    SharedBeneficiaryListFiltersComponent
} from 'src/app/_shared/components/shared-beneficiary-list-filters/shared-beneficiary-list-filters.component';
import {
    SharedBeneficiaryListComponent
} from 'src/app/_shared/components/shared-beneficiary-list/shared-beneficiary-list.component';
import {
    SharedBeneficiarySelectionComponent
} from 'src/app/_shared/components/shared-beneficiary-selection/shared-beneficiary-selection.component';
import { SharedChequeEditComponent } from 'src/app/_shared/components/shared-cheque-edit/shared-cheque-edit.component';
import { SharedCityPickerComponent } from 'src/app/_shared/components/shared-city-picker/shared-city-picker.component';
import {
    SharedCommentTableComponent
} from 'src/app/_shared/components/shared-comment-table/shared-comment-table.component';
import {
    SharedComparedRangeDateComponent,
    SharedComparedRangeNumberComponent
} from 'src/app/_shared/components/shared-compared-range/shared-compared-range.component';
import {
    SharedDaysInMonthEditComponent
} from 'src/app/_shared/components/shared-days-in-month-edit/shared-days-in-month-edit.component';
import {
    SharedFieldValueControlComponent
} from 'src/app/_shared/components/shared-field-value-control/shared-field-value-control.component';
import { SharedIbanEditComponent } from 'src/app/_shared/components/shared-iban-edit/shared-iban-edit.component';
import { SharedIconButtonComponent } from 'src/app/_shared/components/shared-icon-button/shared-icon-button.component';
import {
    SharedInvoicesFiltersComponent
} from 'src/app/_shared/components/shared-invoices-filters/shared-invoices-filters.component';
import {
    SharedInvoicesListComponent
} from 'src/app/_shared/components/shared-invoices-list/shared-invoices-list.component';
import {
    SharedMonthAndYearPickerComponent
} from 'src/app/_shared/components/shared-month-and-year-picker/shared-month-and-year-picker.component';
import {
    SharedMonthAndYearRangeComponent
} from 'src/app/_shared/components/shared-month-and-year-range/shared-month-and-year-range.component';
import {
    SharedMonthRangePickerComponent
} from 'src/app/_shared/components/shared-month-range-picker/shared-month-range-picker.component';
import {
    SharedPasswordComplianceComponent
} from 'src/app/_shared/components/shared-password-compliance/shared-password-compliance.component';
import { SharedStatusComponent } from 'src/app/_shared/components/shared-status/shared-status.component';
import {
    SharedSupplierPickerComponent
} from 'src/app/_shared/components/shared-supplier-picker/shared-supplier-picker.component';
import { SharedVoucherComponent } from 'src/app/_shared/components/shared-voucher/shared-voucher.component';
import { SimpleFileUploadComponent } from 'src/app/_shared/components/simple-file-upload/simple-file-upload.component';
import { SharedTimelineComponent } from 'src/app/_shared/components/timeline/shared-timeline.component';
import { ViewerDocumentComponent } from 'src/app/_shared/components/viewer-document/viewer-document.component';
import { ViewersContainerComponent } from 'src/app/_shared/components/viewers-container/viewers-container.component';
import {
    SharedDateSelectionDialogComponent
} from 'src/app/_shared/dialogs/activity-date-selection-dialog/shared-date-selection-dialog.component';
import {
    SharedDateTimeRangeSelectionDialogComponent
} from 'src/app/_shared/dialogs/activity-date-time-range-selection-dialog/shared-date-time-range-selection-dialog.component';
import { ConfirmDialogComponent } from 'src/app/_shared/dialogs/confirm-dialog/confirm-dialog.component';
import {
    DeleteFolderDialogComponent
} from 'src/app/_shared/dialogs/delete-folder-dialog/delete-folder-dialog.component';
import {
    DocumentBankLocalFileComponent
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-create-document/document-bank-local-file.component';

import {
    DocumentBankFiltersComponent
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-filters/document-bank-filters.component';
import {
    DocumentBankListDialogComponent
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-list-dialog/document-bank-list-dialog.component';
import {
    DocumentBankListComponent
} from 'src/app/_shared/dialogs/document-bank-dialog/document-bank-list/document-bank-list.component';
import {
    DocumentCategoryEditDialogComponent
} from 'src/app/_shared/dialogs/document-category-edit-dialog/document-category-edit-dialog.component';
import {
    EditPasswordDialogComponent
} from 'src/app/_shared/dialogs/edit-password-dialog/edit-password-dialog.component';
import {
    FolderBankAddComponent
} from 'src/app/_shared/dialogs/folder-bank-dialog/folder-bank-add/folder-bank-add.component';

import {
    FolderBankFiltersComponent
} from 'src/app/_shared/dialogs/folder-bank-dialog/folder-bank-filters/folder-bank-filters.component';
import {
    FolderBankListDialogComponent
} from 'src/app/_shared/dialogs/folder-bank-dialog/folder-bank-list-dialog/folder-bank-list-dialog.component';
import { IbanEditDialogComponent } from 'src/app/_shared/dialogs/iban-edit-dialog/iban-edit-dialog.component';
import {
    ImageBankFiltersComponent
} from 'src/app/_shared/dialogs/image-bank-dialog/image-bank-filters/image-bank-filters.component';
import {
    ImageBankListDialogComponent
} from 'src/app/_shared/dialogs/image-bank-dialog/image-bank-list-dialog/image-bank-list-dialog.component';
import {
    LetteredBookEntriesDialogComponent
} from 'src/app/_shared/dialogs/lettered-book-entries-dialog/lettered-book-entries-dialog.component';
import {
    SharedMailDeliveryDialogComponent
} from 'src/app/_shared/dialogs/mail/shared-mail-delivery-dialog/shared-mail-delivery-dialog.component';
import {
    SharedMailDialogComponent
} from 'src/app/_shared/dialogs/mail/shared-mail-dialog/shared-mail-dialog.component';
import {
    SharedMailNonContactableBeneficiariesDialogComponent
} from 'src/app/_shared/dialogs/mail/shared-mail-non-contactable-beneficiaries-dialog/shared-mail-non-contactable-beneficiaries-dialog.component';
import {
    PublishingOptionsMonEspaceCSEDialogComponent
} from 'src/app/_shared/dialogs/publishing-options-mon-espace-cse/publishing-option-mon-espace-cse-dialog.component';
import { RgpdDialogComponent } from 'src/app/_shared/dialogs/rgpd-dialog/rgpd-dialog.component';
import {
    SharedAdvancedSettlementDialogComponent
} from 'src/app/_shared/dialogs/settlements/shared-advanced-settlement-dialog/shared-advanced-settlement-dialog.component';
import {
    SharedCreditsDepositsDialogComponent
} from 'src/app/_shared/dialogs/settlements/shared-credits-deposits-dialog/shared-credits-deposits-dialog.component';
import {
    SharedDeleteCreditDialogComponent
} from 'src/app/_shared/dialogs/settlements/shared-delete-credit-dialog/shared-delete-credit-dialog.component';
import {
    SharedEditRepaymentScheduleDialogComponent
} from 'src/app/_shared/dialogs/settlements/shared-edit-repayment-schedule-dialog/shared-edit-repayment-schedule-dialog.component';
import {
    SharedGenerateCreditDialogComponent
} from 'src/app/_shared/dialogs/settlements/shared-generate-credit-dialog/shared-generate-credit-dialog.component';
import {
    SharedOverpaymentDialogComponent
} from 'src/app/_shared/dialogs/settlements/shared-overpaid-dialog/shared-overpayment-dialog.component';
import {
    SharedAccountingLetteringDialogComponent
} from 'src/app/_shared/dialogs/shared-accounting-lettering-dialog/shared-accounting-lettering-dialog.component';
import {
    SharedAddCommentContainerDialogComponent
} from 'src/app/_shared/dialogs/shared-add-comment-container-dialog/shared-add-comment-container-dialog.component';
import {
    SharedAddCommentDialogComponent
} from 'src/app/_shared/dialogs/shared-add-comment-dialog/shared-add-comment-dialog.component';
import {
    SharedAdvancedRuleComputationDetailDialogComponent
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-computation-detail-dialog/shared-advanced-rule-computation-detail-dialog.component';
import {
    SharedAdvancedRuleComputationsDialogComponent
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-computations-dialog/shared-advanced-rule-computations-dialog.component';
import {
    SharedAdvancedRuleDetailDialogComponent
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-detail-dialog/shared-advanced-rule-detail-dialog.component';
import {
    SharedAdvancedRuleEditDialogComponent
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-edit-dialog/shared-advanced-rule-edit-dialog.component';
import {
    SharedAdvancedRuleLinearFormulaDialogComponent
} from 'src/app/_shared/dialogs/shared-advanced-rules/shared-advanced-rule-linear-formula-dialog/shared-advanced-rule-linear-formula-dialog.component';
import {
    SharedAllocationSettleLoadsDialogComponent
} from 'src/app/_shared/dialogs/shared-allocation-settle-loads-dialog/shared-allocation-settle-loads-dialog.component';
import {
    SharedApplicationParametersSelectionDialogComponent
} from 'src/app/_shared/dialogs/shared-application-parameters-selection-dialog/shared-application-parameters-selection-dialog.component';
import {
    SharedBeneficiaryListDialogComponent
} from 'src/app/_shared/dialogs/shared-beneficiary-list-dialog/shared-beneficiary-list-dialog.component';
import {
    SharedChequeLetterDialogComponent
} from 'src/app/_shared/dialogs/shared-cheque-letter-dialog/shared-cheque-letter-dialog.component';
import {
    SharedCommentTableContainerDialogComponent
} from 'src/app/_shared/dialogs/shared-comment-table-container-dialog/shared-comment-table-container-dialog.component';
import {
    SharedCommentTableContainerComponent
} from 'src/app/_shared/dialogs/shared-comment-table-container/shared-comment-table-container.component';
import {
    SharedContactedBeneficiariesDialogComponent
} from 'src/app/_shared/dialogs/shared-contacted-beneficiaries-dialog/shared-contacted-beneficiaries-dialog.component';
import {
    SharedInvoicesOrdersListDialogComponent
} from 'src/app/_shared/dialogs/shared-invoices-orders-list-dialog/shared-invoices-orders-list-dialog.component';
import {
    SharedMagazineDialogComponent
} from 'src/app/_shared/dialogs/shared-magazine-dialog/shared-magazine-dialog.component';
import {
    SharedPrintOptionsDialogComponent
} from 'src/app/_shared/dialogs/shared-print-options/shared-print-options-dialog.component';
import {
    SharedResetPasswordDialogComponent
} from 'src/app/_shared/dialogs/shared-reset-password-dialog/shared-reset-password-dialog.component';
import {
    SharedSendDetailDialogComponent
} from 'src/app/_shared/dialogs/shared-send-detail-dialog/shared-send-detail-dialog.component';
import {
    ViewerDocumentDialogComponent
} from 'src/app/_shared/dialogs/viewer-document-dialog/viewer-document-dialog.component';
import { ConfirmDirective } from 'src/app/_shared/directives/confirm.directive';
import { DisplayDatePeriodDirective } from 'src/app/_shared/directives/display-date-period.directive';
import { FormElementValueDirective } from 'src/app/_shared/directives/form-element-value.directive';
import { FormFieldChangesDirective } from 'src/app/_shared/directives/form-field-changes.directive';
import { HasModuleDirective } from 'src/app/_shared/directives/has-module.directive';
import { HasVersionDirective } from 'src/app/_shared/directives/has-version.directive';
import { IsMobileDirective } from 'src/app/_shared/directives/is-mobile.directive';
import { LayoutLinkDirective } from 'src/app/_shared/directives/layout-link.directive';
import { ListingConfirmRGPDDialogDirective } from 'src/app/_shared/directives/listing-confirm-rgpd-dialog.directive';
import { NavigateBackDirective } from 'src/app/_shared/directives/navigate-back.directive';
import { NavigateHomeDirective } from 'src/app/_shared/directives/navigate-home.directive';
import { PasswordInputDirective } from 'src/app/_shared/directives/password-input.directive';
import { KalTableModule } from 'src/app/_shared/modules/kal-table/kal-table.module';
import { AbsolutePipe } from 'src/app/_shared/pipes/absolute.pipe';
import { AccountListFilterByNumPipe } from 'src/app/_shared/pipes/account-list-filter-by-num.pipe';
import { ArrayEmptyPipe } from 'src/app/_shared/pipes/array-empty.pipe';
import { ArrayNotEmptyPipe } from 'src/app/_shared/pipes/array-not-empty.pipe';
import { ArrayOfMoreThanOnePipe } from 'src/app/_shared/pipes/array-of-more-than-one.pipe';
import { ArrayOnlyOnePipe } from 'src/app/_shared/pipes/array-only-one.pipe';
import { ArrayPipe } from 'src/app/_shared/pipes/array.pipe';
import { ArticleLabelPipe } from 'src/app/_shared/pipes/article-label.pipe';
import { AttachLabelPipe } from 'src/app/_shared/pipes/attach-label.pipe';
import { BeneficiaryPipe } from 'src/app/_shared/pipes/beneficiary.pipe';
import { ClassColorArchivedPipe } from 'src/app/_shared/pipes/class-color-archived.pipe';
import { CommentActionLabelPipe } from 'src/app/_shared/pipes/comment-action.pipe';
import { CurrencyRangePipe } from 'src/app/_shared/pipes/currency-range.pipe';
import { DurationPipe } from 'src/app/_shared/pipes/duration.pipe';
import { ExcludePipe } from 'src/app/_shared/pipes/exclude.pipe';
import { ExerciseLabelPipe } from 'src/app/_shared/pipes/exercise-label.pipe';
import { FileSizePipe } from 'src/app/_shared/pipes/file-size.pipe';
import { FilteredComparisonOperatorListPipe } from 'src/app/_shared/pipes/filtered-comparison-operator-list.pipe';
import { FindCriterionByIdPipe } from 'src/app/_shared/pipes/find-criterion-by-id.pipe';
import { FindInListByIdPipe } from 'src/app/_shared/pipes/find-in-list.pipe';
import { GetBeneficiaryFromIdPipe } from 'src/app/_shared/pipes/get-beneficiary-from-id.pipe';
import { GetSupplierFromIdPipe } from 'src/app/_shared/pipes/get-supplier-from-id.pipe';
import { GpsPipe } from 'src/app/_shared/pipes/gps.pipe';
import { HighlightPipe } from 'src/app/_shared/pipes/highlight.pipe';
import { IbanPipe } from 'src/app/_shared/pipes/iban.pipe';
import { IsEqualOperatorPipe } from 'src/app/_shared/pipes/is-equal-operator.pipe';
import { IsNumberCriterionPipe } from 'src/app/_shared/pipes/is-number-criterion.pipe';
import { JoinPipe } from 'src/app/_shared/pipes/join.pipe';
import { JournalLabelPipe } from 'src/app/_shared/pipes/journal-label.pipe';
import { MandateLabelPipe } from 'src/app/_shared/pipes/mandate-label.pipe';
import { MonthRangePipe } from 'src/app/_shared/pipes/month-range.pipe';
import { NeedDaysInMonthFormIdPipe } from 'src/app/_shared/pipes/need-days-in-month-form-id.pipe';
import { PhonePipe } from 'src/app/_shared/pipes/phone.pipe';
import { RepartitionKeyLabelPipe } from 'src/app/_shared/pipes/repartition-key-label.pipe';
import { RepeatStringPipe } from 'src/app/_shared/pipes/repeat-string.pipe';
import { SanitizePipe } from 'src/app/_shared/pipes/sanitize.pipe';
import { SectionLabelFromPlanPipe } from 'src/app/_shared/pipes/section-from-plan.pipe';
import { StatusClassGedPipe } from 'src/app/_shared/pipes/status-ged.pipe';

import { YesNo } from 'src/app/_shared/pipes/yes-no.pipe';
import {
    SharedAllocationAccessibilityState
} from 'src/app/_shared/stores/allocation-accessibility/shared-allocation-accessibility.state';
import { AnalyticalPlanState } from 'src/app/_shared/stores/analytical-plan/analytical-plan.state';
import { ExerciceState } from 'src/app/_shared/stores/exercices/exercices.state';
import { SharedFolderState } from 'src/app/_shared/stores/folder/folder.state';
import { HomeState } from 'src/app/_shared/stores/home/home.state';
import { SharedListingState } from 'src/app/_shared/stores/listing/shared-listing.state';
import { ReferenceYearsState } from 'src/app/_shared/stores/reference-years/reference-years.state';
import {
    SharedAdvancedSettlementState
} from 'src/app/_shared/stores/settlements/shared-advanced-settlement/shared-advanced-settlement.state';
import {
    SharedPaymentMethodsState
} from 'src/app/_shared/stores/settlements/shared-payment-methods/shared-payment-methods.state';
import {
    SharedAllocationExecutionState
} from 'src/app/_shared/stores/shared-allocation-execution/shared-allocation-execution.state';
import {
    SharedChequesAllocationState
} from 'src/app/_shared/stores/shared-cheques-allocation/shared-cheques-allocation-state.service';
import { SharedConsumerState } from 'src/app/_shared/stores/shared-consumer/shared-consumer-state';
import { SharedMagazineState } from 'src/app/_shared/stores/shared-magazine/shared-magazine.state';
import {
    SharedNavigationManagerState
} from 'src/app/_shared/stores/shared-navigation-manager/shared-navigation-manager.state';
import {
    SharedSubventionCriteriaState
} from 'src/app/_shared/stores/shared-subvention-criteria/shared-subvention-criteria-state';
import {
    FolderBankListComponent
} from 'src/app/_shared/dialogs/folder-bank-dialog/folder-bank-list/folder-bank-list.component';
import { ArrayPropertyToStringListPipe } from 'src/app/_shared/pipes/array-property-to-string-list.pipe';
import { FilteredAccountsByNumberPipe } from 'src/app/_shared/pipes/filtered-accounts-by-number.pipe';
import { SharedSearchbarListComponent } from 'src/app/_shared/components/shared-searchbar-list/shared-searchbar-list.component';
import { SharedSearchbarParametersDirective } from 'src/app/_shared/directives/shared-searchbar-parameters.directive';
import { TernaryValuePipe } from 'src/app/_shared/pipes/ternary-value.pipe';
import { FilteredListByArchivePipe } from 'src/app/_shared/pipes/filtered-list-by-archive.pipe';
import { DateWithOperatorComponent } from 'src/app/_shared/components/date-with-operator/date-with-operator.component';
import { SharedAdvancedRuleComponent } from 'src/app/_shared/components/shared-advanced-rule/shared-advanced-rule.component';
import { SharedMailPreviewDialogComponent } from 'src/app/_shared/dialogs/shared-mail-preview-dialog/shared-mail-preview-dialog.component';
import { SharedNotificationSettingsComponent } from 'src/app/_shared/components/shared-notification-settings/shared-notification-settings.component';
import { FormComponentsModule } from 'src/app/_shared/modules/form-component/form-components.module';
import { SharedAddCityDialogComponent } from 'src/app/_shared/dialogs/shared-add-new-city-dialog/shared-add-city-dialog.component';
import { SharedAddCountryDialogComponent } from 'src/app/_shared/dialogs/shared-add-new-country-dialog/shared-add-country-dialog.component';
import { SharedEditPasswordComponent } from 'src/app/_shared/components/shared-edit-password/shared-edit-password.component';
import { IsStringNullOrEmptyPipe } from 'src/app/_shared/pipes/is-string-null-or-empty.pipe';
import { ProgressModule } from 'src/app/_shared/components/progress/progress.module';
import { IntegerPipe } from './pipes/integer.pipe';

const dialogs = [
    ConfirmDialogComponent,
    ImageBankListDialogComponent,
    DocumentBankListDialogComponent,
    FolderBankListDialogComponent,
    DeleteFolderDialogComponent,
    RgpdDialogComponent,
    IbanEditDialogComponent,
    SharedAddCommentDialogComponent,
    IbanEditDialogComponent,
    ViewerDocumentDialogComponent,
    PublishingOptionsMonEspaceCSEDialogComponent,
    SharedMailNonContactableBeneficiariesDialogComponent,
    SharedMailDialogComponent,
    SharedPrintOptionsDialogComponent,
    SharedResetPasswordDialogComponent,
    SharedBeneficiaryListDialogComponent,
    SharedContactedBeneficiariesDialogComponent,
    SharedSendDetailDialogComponent,
    SharedMailDeliveryDialogComponent,
    SharedInvoicesOrdersListDialogComponent,
    SharedCreditsDepositsDialogComponent,
    SharedOverpaymentDialogComponent,
    SharedGenerateCreditDialogComponent,
    SharedAdvancedSettlementDialogComponent,
    SharedDeleteCreditDialogComponent,
    SharedEditRepaymentScheduleDialogComponent,
    LetteredBookEntriesDialogComponent,
    SharedAccountingLetteringDialogComponent,
    SharedAddCommentContainerDialogComponent,
    SharedCommentTableContainerDialogComponent,
    SharedCommentTableContainerComponent,
    SharedApplicationParametersSelectionDialogComponent,
    SharedDateTimeRangeSelectionDialogComponent,
    SharedDateSelectionDialogComponent,
    SharedAllocationSettleLoadsDialogComponent,
    EditPasswordDialogComponent,
    DocumentCategoryEditDialogComponent,
    SharedAdvancedRuleEditDialogComponent,
    SharedAdvancedRuleComputationsDialogComponent,
    SharedAdvancedRuleLinearFormulaDialogComponent,
    SharedAdvancedRuleDetailDialogComponent,
    SharedAdvancedRuleComputationDetailDialogComponent,
    SharedMailPreviewDialogComponent,
    SharedAddCityDialogComponent,
    SharedAddCountryDialogComponent
];

const declarations = [
    ClassColorArchivedPipe,
    RepartitionKeyLabelPipe,
    ArrayOnlyOnePipe,
    ArrayOfMoreThanOnePipe,
    SharedBeneficiaryListComponent,
    SharedBeneficiaryListFiltersComponent,
    ImageBankFiltersComponent,
    DocumentBankFiltersComponent,
    FolderBankFiltersComponent,
    SimpleFileUploadComponent,
    ConfirmDirective,
    LayoutLinkDirective,
    IsMobileDirective,
    DisplayDatePeriodDirective,
    SanitizePipe,
    DurationPipe,
    ArrayNotEmptyPipe,
    ArrayEmptyPipe,
    ArrayPipe,
    HighlightPipe,
    ExcludePipe,
    IbanPipe,
    IntegerPipe,
    FileSizePipe,
    PhonePipe,
    YesNo,
    GpsPipe,
    AbsolutePipe,
    CommentActionLabelPipe,
    JournalLabelPipe,
    ArticleLabelPipe,
    JoinPipe,
    ExerciseLabelPipe,
    SharedStatusComponent,
    BeneficiaryPickerComponent,
    LazyListPickerComponent,
    BeneficiaryPictureComponent,
    ButtonCloseComponent,
    ButtonCloseComponent,
    SharedCommentEditComponent,
    InputCounterComponent,
    ColorPickerComponent,
    PasswordInputDirective,
    ViewerDocumentComponent,
    SharedMailContainerComponent,
    ViewersContainerComponent,
    PartNumberComponent,
    AnalyticalPlanDistributerComponent,
    SharedMailComponent,
    SharedCommentTableComponent,
    NavigateBackDirective,
    SharedCityPickerComponent,
    SharedPasswordComplianceComponent,
    SharedVoucherComponent,
    SharedBeneficiaryContactSelectionComponent,
    SharedMailPublipostageTagsComponent,
    SharedMagazineComponent,
    SharedMagazineDialogComponent,
    SharedSupplierPickerComponent,
    ListingComponent,
    ListingTitleDirective,
    ListingActionGroupedDirective,
    SharedInvoicesListComponent,
    SharedInvoicesFiltersComponent,
    ListingSearchbarContentDirective,
    ListingFooterDirective,
    ListingHeaderDirective,
    ListingAboveSearchbarContentDirective,
    ListingAfterSearchbarButtonsDirective,
    HasModuleDirective,
    HasVersionDirective,
    SharedChequeLetterDialogComponent,
    SharedFieldValueControlComponent,
    SharedAdvancedSettlementComponent,
    SharedPaymentMethodsComponent,
    SharedAllocationExecutionComponent,
    SharedAllocationEditEnvelopeComponent,
    SharedAllocationDetailEnvelopeComponent,
    SharedAllocationAccessibilityDetailComponent,
    SharedAllocationAccessibilityEditComponent,
    SharedAnalyticalPlanDistributerComponent,
    SharedDaysInMonthEditComponent,
    SharedAnalyticalPlanDistributerByMovementComponent,
    SharedAnalyticalPlanDistributerByAccountComponent,
    SharedAnalyticalPlanDistributerByModelComponent,
    SharedAnalyticalPlanPickerComponent,
    BeneficiaryPipe,
    ListingCountResultsLabelDirective,
    ListingBetweenTableAndPagingDirective,
    SharedAllocationListComponent,
    SharedAllocationDetailComponent,
    SharedAllocationInformationsComponent,
    SharedAllocationEditComponent,
    ListingQuickFiltersDirective,
    ListingConfirmRGPDDialogDirective,
    SharedAccountingBudgetsChildrenListComponent,
    SharedAdministrativeStatusComponent,
    FormFieldChangesDirective,
    FormElementValueDirective,
    SharedMonthRangePickerComponent,
    SharedComparedRangeNumberComponent,
    SharedComparedRangeDateComponent,
    SharedChequeEditComponent,
    SharedIbanEditComponent,
    SharedEditRepaymentScheduleComponent,
    SharedTimelineComponent,
    SharedMonthAndYearPickerComponent,
    SharedMonthAndYearRangeComponent,
    SharedIbanEditComponent,
    SharedEditRepaymentScheduleComponent,
    SharedIconButtonComponent,
    SectionLabelFromPlanPipe,
    CurrencyRangePipe,
    MonthRangePipe,
    AttachLabelPipe,
    SharedBeneficiarySelectionComponent,
    NavigateHomeDirective,
    GetBeneficiaryFromIdPipe,
    GetSupplierFromIdPipe,
    MandateLabelPipe,
    AttachLabelPipe,
    IconInvalidFormControlComponent,
    SharedAddressDetailComponent,
    SharedAddressEditComponent,
    DocumentBankLocalFileComponent,
    DocumentBankListComponent,
    FolderBankListComponent,
    FolderBankAddComponent,
    AccountListFilterByNumPipe,
    FindInListByIdPipe,
    StatusClassGedPipe,
    ArrayPropertyToStringListPipe,
    FilteredAccountsByNumberPipe,
    SharedSearchbarListComponent,
    SharedSearchbarParametersDirective,
    TernaryValuePipe,
    FilteredListByArchivePipe,
    IsNumberCriterionPipe,
    FindCriterionByIdPipe,
    IsEqualOperatorPipe,
    FilteredComparisonOperatorListPipe,
    NeedDaysInMonthFormIdPipe,
    RepeatStringPipe,
    IsStringNullOrEmptyPipe,
    DateWithOperatorComponent,
    SharedAdvancedRuleEditTableComponent,
    SharedAdvancedRuleCriterionValueControlComponent,
    SharedAdvancedRuleCriterionParametersControlComponent,
    SharedAdvancedRuleDetailComponent,
    SharedAdvancedRuleDetailTableComponent,
    SharedAdvancedRuleCriterionValueComponent,
    SharedAdvancedRuleCriterionParametersDetailComponent,
    SharedAdvancedRuleComponent,
    SharedNotificationSettingsComponent,
    SharedEditPasswordComponent,
    ...dialogs
];

const imports = [
    CommonModule,
    ReactiveFormsModule,
    KaligraphiModule,
    KalTableModule,
    ScrollingModule,
    CdkTableModule, // TODO a supprimer une fois qu'on a tout passé sur le nouveau tableau
    EditorModule,
    FormComponentsModule,
    ProgressModule
];

@NgModule({
    declarations,
    imports: [
        ...imports,
        NgxsModule.forFeature([
            SharedFolderState,
            ExerciceState,
            AnalyticalPlanState,
            SharedListingState,
            SharedNavigationManagerState,
            ReferenceYearsState,
            SharedMagazineState,
            HomeState,
            SharedAdvancedSettlementState,
            SharedPaymentMethodsState,
            SharedAllocationExecutionState,
            SharedSubventionCriteriaState,
            SharedAllocationAccessibilityState,
            SharedConsumerState,
            SharedChequesAllocationState
        ])
    ],
    exports: [
        ...declarations,
        ...imports
    ]
})
export class SharedModule {
}
